export default __webpack_public_path__ + "static/media/ico_quien.1cb5520a.svg";